<template>
  <div>
    <b-container>

      <h1>Management</h1>

      <div>
        <h2>Services</h2>
        <b-row>
          <b-col>
            <h3>Graphical interface</h3>
            <json-editor :objData="servicesObject" v-model="servicesJson"></json-editor>

            <b-button variant="success" @click="submitServicesChanges">Save changes</b-button>
          </b-col>
          <b-col>
            <h3>JSON Schema</h3>
            <div class="code-pre services-json">
              <div slot="content">
                  <pre>
                    <code class="json" id="res_code"></code>
                  </pre>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button variant="danger" @click="submitOriginalServices">Replace with original services</b-button>
          </b-col>
        </b-row>
      </div>

      <div>
        <h2>Specialities</h2>
        <b-row>
          <b-col>
            <h3>Graphical interface</h3>
            <json-editor :objData="specialitiesObject" v-model="specialitiesJson"></json-editor>

            <b-button variant="success" @click="submitSpecialitiesChanges">Save changes</b-button>
          </b-col>
          <b-col>
            <h3>JSON Schema</h3>
            <div class="code-pre services-json">
              <div slot="content">
                  <pre>
                    <code class="json" id="res_code"></code>
                  </pre>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button variant="danger" @click="submitOriginalSpecialities">Replace with original specialities</b-button>
          </b-col>
        </b-row>
      </div>

    </b-container>
  </div>
</template>

<script>
import router from '@/router'
import Multiselect from 'vue-multiselect'
import JsonEditor from '@/app/jsonEditor/JsonEditor.vue'

import { SERVICES } from '@/util/services'
import { SPECIALITIES } from '@/util/specialities'

import hljs from 'highlight.js'

export default {
  name: 'Management',
  components: {
    'multiselect': Multiselect,
    'JsonEditor': JsonEditor
  },
  data () {
    return {
      defaultServicesJson: SERVICES,
      defaultSpecialitiesJson: SPECIALITIES,
      servicesJson: {},
      specialitiesJson: {}
    }
  },
  methods: {

  },
  computed: {
    servicesObject: function () {
      let services = this.$store.state.servicesObject
      let servicesObject = { services }
      this.servicesJson = services

      return servicesObject
    },
    specialitiesObject: function () {
      let specialities = this.$store.state.specialitiesObject
      let specialitiesObject = { specialities }
      this.specialitiesJson = specialities

      return specialitiesObject
    }
  },
  methods: {
    submitOriginalServices: function () {
      this.servicesJson = SERVICES
      this.submitServicesChanges()
    },
    submitOriginalSpecialities: function () {
      this.specialitiesJson = SPECIALITIES
      this.submitSpecialitiesChanges()
    },
    submitServicesChanges: function () {
      // Submit to DB
      console.log(this.servicesJson)

      let jsonData = this.servicesJson

      jsonData && Object.keys(jsonData).forEach(key => {
        const nestedContent = jsonData[key]

        if (typeof nestedContent === 'object') {
          Object.keys(nestedContent).forEach(docTitle => {

            DB.collection(key)
              .doc(docTitle)
              .set(nestedContent[docTitle])
              .then((res) => {
                console.log('Document successfully written!')
              })
              .catch((error) => {
                console.error('Error writing document: ', error)
              })
          })
        }
      })
    },
    submitSpecialitiesChanges: function () {
      // Submit to DB
      let jsonData = this.specialitiesJson

      jsonData && Object.keys(jsonData).forEach(key => {
        const nestedContent = jsonData[key]
        if (typeof nestedContent === 'object') {
          Object.keys(nestedContent).forEach(docTitle => {
            DB.collection(key)
              .doc(docTitle)
              .set(nestedContent[docTitle])
              .then((res) => {
                console.log('Document successfully written!')
              })
              .catch((error) => {
                console.error('Error writing document: ', error)
              })
          })
        }
      })
    },
    //JSON format print
    formatJson: function(txt, compress) {
      var indentChar = '  '
      if (/^\s*$/.test(txt)) {
        console.error('Empty data')
        return;
      }
      try {
        var data = eval('(' + txt + ')')
      } catch (e) {
        throw ('Syntax error: ' + e.description, "err")
        return;
      }
      var draw = [],
        last = false,
        This = this,
        line = compress ? '' : '\n',
        nodeCount = 0,
        maxDepth = 0;
      var notify = function(name, value, isLast, indent, formObj) {
        nodeCount++
        for (var i = 0, tab = ''; i < indent; i++) tab += indentChar; /* 缩进HTML */
        tab = compress ? '' : tab
        maxDepth = ++indent
        if (value && value.constructor == Array) {
          draw.push(
            tab + (formObj ? '"' + name + '":' : '') + '[' + line
          )
          for (var i = 0; i < value.length; i++)
            notify(i, value[i], i == value.length - 1, indent, false);
          draw.push(
            tab + ']' + (isLast ? line : ',' + line)
          )
        } else if (value && typeof value == 'object') {
          draw.push(
            tab + (formObj ? '"' + name + '":' : '') + '{' + line
          )
          var len = 0,
            i = 0;
          for (var key in value) len++
          for (var key in value) notify(key, value[key], ++i == len, indent, true)
          draw.push(
            tab + '}' + (isLast ? line : ',' + line)
          )
        } else {
          if (typeof value == 'string') value = '"' + value + '"'
          draw.push(
            tab +
            (formObj ? '"' + name + '":' : '') +
            value +
            (isLast ? '' : ',') +
            line
          );
        }
      };
      var isLast = true,
        indent = 0;
      notify('', data, isLast, indent, false)
      return draw.join('')
    },
    drawResCode: function (content) {
      var target = document.getElementById('res_code');
      target.textContent = content
      hljs.highlightBlock(target)
    },
  },
  created () {

  },
  mounted: function() {
    let c = this.formatJson(JSON.stringify(this.servicesJson))
    this.drawResCode(c)
  },
  watch: {
    'servicesJson': function () {
      let c = this.formatJson(JSON.stringify(this.servicesJson))
      this.drawResCode(c)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/app.scss';

  .services {
    .row {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;

      .title {
        font-weight: bold;
        font-size: 120%;
      }
    }

    .sub-service {

    }
  }

  .services-json {
    max-height: 500px;
    overflow-y: scroll;
  }

  pre {
    text-align: left;
  }
  .hljs {
    display: block;
    overflow-x: auto;
    padding: 0.5em;
    color: #333;
    background: #f8f8f8;
  }

  .hljs-comment,
  .hljs-quote {
    color: #998;
    font-style: italic;
  }

  .hljs-keyword,
  .hljs-selector-tag,
  .hljs-subst {
    color: #333;
    font-weight: bold;
  }

  .hljs-number,
  .hljs-literal,
  .hljs-variable,
  .hljs-template-variable,
  .hljs-tag .hljs-attr {
    color: #008080;
  }

  .hljs-string,
  .hljs-doctag {
    color: #d14;
  }

  .hljs-title,
  .hljs-section,
  .hljs-selector-id {
    color: #900;
    font-weight: bold;
  }

  .hljs-subst {
    font-weight: normal;
  }

  .hljs-type,
  .hljs-class .hljs-title {
    color: #458;
    font-weight: bold;
  }

  .hljs-tag,
  .hljs-name,
  .hljs-attribute {
    color: #000080;
    font-weight: normal;
  }

  .hljs-regexp,
  .hljs-link {
    color: #009926;
  }

  .hljs-symbol,
  .hljs-bullet {
    color: #990073;
  }

  .hljs-built_in,
  .hljs-builtin-name {
    color: #0086b3;
  }

  .hljs-meta {
    color: #999;
    font-weight: bold;
  }

  .hljs-deletion {
    background: #fdd;
  }

  .hljs-addition {
    background: #dfd;
  }

  .hljs-emphasis {
    font-style: italic;
  }

  .hljs-strong {
    font-weight: bold;
  }
</style>
